// Italian-only labels for the public catalog & product pages.
export const labels = {
  brand_name: "MB Réserve",
  nav: { home: "Home", catalog: "Catalogo", contact: "Contatti" },

  home: {
    title: "MB Réserve",
    subtitle:
      "Profumi di nicchia selezionati personalmente.\nFragranze autentiche scelte per carattere, eleganza e personalità.",
    cta: "Esplora la Collezione",
    philosophy_overline: "La Nostra Filosofia",
    philosophy_title: "Profumi scelti, non semplicemente venduti.",
    philosophy_text: [
      "Ogni fragranza presente in questa collezione è stata selezionata personalmente tra le migliori creazioni della profumeria artistica internazionale.",
      "Non seguo le mode del momento né le classifiche commerciali.",
      "Cerco profumi che abbiano carattere, qualità delle materie prime, personalità e capacità di lasciare un ricordo.",
      "Questa non è una profumeria tradizionale, ma una raccolta privata di essenze rare e ricercate, condivisa con chi ama distinguersi.",
    ],
    highlights_overline: "Selezione del Momento",
    highlights_title: "Pezzi rari, scelti per voi",
    view_all: "Vedi tutta la collezione",
    selections_overline: "Le Mie Selezioni",
    selections_title: "Le mie selezioni",
    selections_subtitle:
      "Una selezione personale di fragranze che considero particolarmente interessanti per qualità, originalità, eleganza o rapporto qualità-prezzo.",
    request_overline: "Su Misura",
    request_title: "Non trovi il profumo che cerchi?",
    request_text: [
      "Il catalogo viene aggiornato costantemente, ma non tutte le fragranze disponibili sono pubblicate sul sito.",
      "Se stai cercando un profumo specifico, scrivici su WhatsApp e verificheremo disponibilità, formato e prezzo.",
    ],
    request_cta: "Chiedi su WhatsApp",
    request_msg:
      "Ciao, sto cercando un profumo specifico. Puoi verificarmi disponibilità, formato e prezzo?",
    why_overline: "Il Metodo",
    why_title: "Perché questa collezione",
    why_text: [
      "Negli anni ho selezionato centinaia di fragranze, provandole, confrontandole e studiandole.",
      "In questo spazio trovi solo profumi che ritengo realmente degni di essere scoperti.",
      "Nessun algoritmo, nessuna sponsorizzazione, nessuna classifica.",
      "Solo una selezione personale costruita con passione.",
    ],
    stats: {
      curated: "Essenze curate",
      brands: "Maison rappresentate",
      private: "Selezione privata",
    },
  },

  catalog: {
    overline: "Collezione Privata",
    title: "Il Catalogo",
    intro: "Una selezione viva, in continua evoluzione. Per disponibilità, scrivici su WhatsApp.",
    filters_title: "Filtri",
    filter_brand: "Marca",
    filter_gender: "Genere",
    filter_season: "Stagionalità",
    filter_availability: "Disponibilità",
    filter_price: "Prezzo",
    all: "Tutti",
    empty: "Nessun profumo trovato con questi filtri.",
    reset: "Azzera filtri",
    loading: "Caricamento…",
  },

  product: {
    back: "← Torna al catalogo",
    overline_label: "Scheda Profumo",
    brand: "Marca",
    name: "Nome",
    format: "Formato",
    status: "Stato",
    price: "Prezzo",
    availability: "Disponibilità",
    gender: "Genere",
    year: "Anno",
    concentration: "Concentrazione",
    season: "Stagionalità",
    sillage: "Scia",
    longevity: "Durata",
    notes: "Note olfattive",
    short_description: "Descrizione breve",
    full_description: "Descrizione",
    whatsapp_cta: "Contattami su WhatsApp",
    whatsapp_msg: (name) =>
      `Ciao, sono interessato al profumo ${name || ""}.`,
    not_found: "Profumo non trovato.",
    no_image: "Foto in arrivo",
    no_data: "Da inserire",
  },

  contact: {
    overline: "Una conversazione privata",
    title: "Contattaci",
    text:
      "Una consulenza olfattiva privata e dedicata. Scrivici per scoprire la collezione, ricevere consigli o richiedere un'essenza in particolare.",
    whatsapp_cta: "Scrivici su WhatsApp",
    whatsapp_msg:
      "Buongiorno, vorrei avere informazioni sulla collezione MB Réserve.",
    number_label: "Telefono",
    hours_label: "Disponibilità",
    hours_value: "Lun — Sab · 10:00 — 19:00",
    response_label: "Risposta",
    response_value: "Entro 24 ore",
  },

  footer: {
    tagline: "Una collezione privata di profumi di nicchia e lusso.",
    navigation: "Navigazione",
    contact: "Contatto",
    rights: "Tutti i diritti riservati.",
    disclaimer:
      "Sito vetrina senza vendita online. Le essenze sono trattate come oggetti da collezione.",
  },

  admin: {
    title: "Pannello Editor",
    subtitle: "Gestione del catalogo MB Réserve",
    login_title: "Accesso riservato",
    login_subtitle: "Inserisci le credenziali per modificare il catalogo.",
    email: "Email",
    password: "Password",
    login_cta: "Accedi",
    logout: "Esci",
    invalid: "Credenziali non valide.",
    open_public: "Apri sito",

    list_title: "Catalogo · {count} schede",
    new_perfume: "+ Nuova scheda",
    edit: "Modifica",
    hide: "Nascondi",
    show: "Mostra",
    delete: "Elimina",
    confirm_delete: "Eliminare definitivamente questa scheda?",
    hidden_label: "Nascosto",
    visible_label: "Visibile",

    edit_title: "Modifica scheda",
    images_section: "Immagini",
    main_image: "Immagine principale",
    additional_images: "Immagini aggiuntive (max 3)",
    upload_main: "Carica immagine principale",
    upload_additional: "Carica immagine aggiuntiva",
    remove: "Rimuovi",

    fields_section: "Dati profumo",
    placeholder_empty: "—",

    save: "Salva modifiche",
    saving: "Salvataggio…",
    saved: "Salvato",
    back_to_list: "← Torna alla lista",

    gender_options: ["", "Uomo", "Donna", "Unisex"],
    availability_options: ["", "Disponibile", "Esaurito", "Su richiesta"],

    field_labels: {
      brand: "Marca",
      name: "Nome profumo",
      size_ml: "Formato (ml)",
      condition: "Stato (es. Nuovo / Usato)",
      price: "Prezzo (es. € 280)",
      availability: "Disponibilità",
      gender: "Genere",
      year: "Anno di uscita",
      concentration: "Concentrazione",
      seasonality: "Stagionalità",
      longevity: "Durata",
      sillage: "Scia",
      olfactory_notes: "Note olfattive",
      short_description: "Descrizione breve",
      full_description: "Descrizione completa",
      visible: "Visibile nel catalogo pubblico",
      featured_in_selections: "Mostra in \"Le mie selezioni\" (homepage)",
      personal_recommendation: "Consiglio personale (breve)",
    },
  },
};

export const GENDERS = [
  "Uomo",
  "Donna",
  "Unisex",
  "Unisex tendente maschile",
  "Unisex tendente femminile",
];
export const AVAILABILITIES = [
  "Disponibile",
  "In arrivo",
  "Prenotabile",
  "Prenotalo via WhatsApp",
  "Su richiesta",
  "Verifica disponibilità su WhatsApp",
  "Esaurito",
];
export const SEASONS = [
  "Primavera / Estate",
  "Autunno / Inverno",
  "4 Stagioni",
  "Tutto l'anno",
];
export const CONDITIONS = [
  "Nuovo sigillato con cellophane",
  "Nuovo sigillato",
  "Nuovo senza confezione",
  "Usato come campione (oltre 90% residuo)",
  "Usato come campione (70-90% residuo)",
  "Usato come campione (50-70% residuo)",
];
export const SILLAGES = [
  "Bassa",
  "Media",
  "Media Alta",
  "Alta",
  "Molto Alta",
  "Estrema",
];
export const LONGEVITIES = [
  "Bassa",
  "Media",
  "Media Alta",
  "Alta",
  "Molto Alta",
  "Estrema",
];
export const CONCENTRATIONS = [
  "Parfum",
  "Extrait de Parfum",
  "Eau de Parfum",
  "Eau de Toilette",
  "Cologne",
];
